import React, {useRef, useState} from "react";
import { getMessage} from "../util";
import Container from "@material-ui/core/Container";
import Unknown from "./responses/Unknown";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core/styles";
import HTTPClient from "../HTTPClient";
import Loading from "./Loading";
import NotInMeetingRoll from "./responses/NotInMeetingRoll";
import AskPhone from "./responses/AskPhone";
import Late from "./responses/Late";
import WrongSC from "./responses/WrongSC";

const useStyles = makeStyles(theme => ({
        paper: {
            marginTop: theme.spacing(4),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        question: {
            marginTop: theme.spacing(4),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        checkboxLabel: {
            fontSize: '1.5rem'
        },
        grid: {
            alignItems: 'center',
        },

        carnet: {
            width: '100%',
            maxWidth: '200px',
            display: 'block',
            'margin-left':
                'auto',
            'margin-right':
                'auto',
        },
        form: {
            width: '100%', // Fix IE 11 issue.
            marginTop: theme.spacing(1)
        },
        submit: {
            margin: theme.spacing(3, 0, 2),
        },
    }
));

export const ID_SC = (props) => {
    const classes = useStyles();

    const rutRef = useRef();
    const serialRef = useRef();

    const [serialText, setSerialText] = useState('');
    const [status, setStatus] = useState('ok');
    const [loading, setLoading] = useState(false);
    const [jwt, setJwt] = useState(null);
    const [reason, setReason] = useState(null);
    const [myMistake, setMyMistake] = useState(false);
    const [wrongCounter, setWrongCounter] = useState(0);

    const login = (event) => {
        event.preventDefault();

        const serialNoFormat = serialRef.current.value.replace(/[^0-9a-zA-Z]/g, "").toUpperCase();

        const serialInvalid = !(serialNoFormat && (/^(C[A-NP-Z1-9]{5})$/.test(serialNoFormat) || /^(A0\d{8})$/.test(serialNoFormat) || /^(\d{9})$/.test(serialNoFormat)));

        if (serialInvalid) {
            setSerialText((!serialNoFormat) ? getMessage(props.meeting.meeting_type,'must_put_pass',props.messages) : (serialInvalid ? getMessage(props.meeting.meeting_type,'wrong_input_pass',props.messages) : ""));
            return;
        }

        const data = {
            rut: rutRef.current.value,
            serial: serialNoFormat,
            meeting_id: props.meeting.slug
        }


        setLoading(true);
        HTTPClient({
            method: "post",
            data: data,
            url:
                process.env.REACT_APP_API_URL +
                "/login/id_sc"
        })
            .then(response => {
                setLoading(false);
                switch (response.data.status) {
                    case 'ok':
                        window.location = (props.meeting ? '/meeting'  : '/');

                        return;
                    case 'wrong':
                        if (wrongCounter > 0) {
                            setJwt(response.data.message);
                            setReason("segundo intento con serial malo");
                            setStatus('askphone');
                        } else {
                            setWrongCounter(wrongCounter+1);
                            setStatus('wrongSerial');
                        }
                        //setStatus('wrongSerial');
                        return;
                    case 'notfound':
                        setStatus('notfound');
                        return;
                    case 'safeconduct':

                        window.location = (props.meeting ? '/meeting'  : '/');

                        return;
                    case 'quorum':
                        setStatus('late');
                        return;
                    default:
                        setJwt(response.data.message);
                        setReason("razón desconocida");
                        setMyMistake(true);
                        setStatus('askphone');
                        // setStatus('unknown');
                        return;
                }
            })
            .catch((error) => {
                setLoading(false);
            });

    }

    const setSerialInput = () => {
        /*
        if (isControlKey(event)) {
            return;
        }
         */

        const noFormat = serialRef.current.value.replace(/[^0-9a-zA-Z]/g, "").toUpperCase();
        let withFormat = noFormat.replace(/[^A-Z0-9]/g, "").toUpperCase();
        serialRef.current.value = withFormat;
        setSerialText((/^(C[A-NP-Z1-9]{5})$/.test(noFormat) || /^(A0\d{8})$/.test(noFormat) || /^(\d{9})$/.test(noFormat)) ? "" : " ")

    };


    return (

        <Container component="main" maxWidth="xs">
            {status === 'wrongSerial' && <WrongSC meeting={props.meeting} messages={props.messages} open={status === 'wrongSerial'} handleClose={() => setStatus('ok')}/>}
            {status === 'unknown' && <Unknown meeting={props.meeting} messages={props.messages} open={status === 'unknown'} handleClose={() => setStatus('ok')}/>}
            {status === 'notfound' && <NotInMeetingRoll messages={props.messages} open={status === 'notfound'} handleClose={() => setStatus('ok')} meeting={props.meeting}/>}
            {status === 'late' &&  <Late  messages={props.messages} open={true} handleClose={() => setStatus('ok')} meeting={props.meeting}/>}

            {status === 'askphone' && <AskPhone  messages={props.messages} reason={reason} jwt={jwt} my_mistake={myMistake} meeting={props.meeting} handleClose={() => setStatus('ok')} />}

            <CssBaseline/>
            <div className={classes.paper}>

                <Typography component="h1" variant="h5">
                    { getMessage(props.meeting.meeting_type,'welcome',props.messages).format(props.meeting.title)}
                </Typography>
                <form className={classes.form} noValidate>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="identity"
                        label={getMessage(props.meeting.meeting_type,'id_label',props.messages)}
                        name="identity"
                        autoFocus
                        inputRef={rutRef}
                    />
                    <TextField
                        error={serialText !== ''}
                        helperText={serialText.trim()}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="serial"
                        label={getMessage(props.meeting.meeting_type,'password_label',props.messages)}
                        type="serial"
                        id="serial"
                        inputRef={serialRef}
                        onChange={() => setSerialInput(serialRef, setSerialText)}
                    />

                    {loading ? (
                        <Loading/>
                    ) : (
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={login}
                        >
                            {getMessage(props.meeting.meeting_type,'button_verify_identity',props.messages)}                        </Button>
                    )}
                </form>
            </div>

        </Container>

    );
}

export default ID_SC;